module.exports = __webpack_public_path__ + "img/four-straighten.dda340a8.jpg";